import React from "react";
import { TextDescription, TextTitle } from "components/Texts";

import CampaignZone from "./CampaignZone";
import Column from "components/Column";
import ContactSpecialistBtn from "./ContactSpecialistBtn";
import Icon from "components/Icon";
import Row from "components/Row";
import Section from "components/Section";
import SuggestionNumber from "./SuggestionNumber";
import colors from "styles/colors";
import DateFormatter from "../../modules/utils/DateFormatter";
import { useTranslation } from "react-i18next";

const Opportunity = ({ data = {} }) => {
  const [t] = useTranslation();
  const campaigns = data.campaigns || [];

  return campaigns.length ? (
    <Section className="item" margin="0">
      <Row columnSpacing="8px" alignItems="center">
        <Column wrap>
          <Icon name="icon-trending" size="26px" color={colors.primary} />
        </Column>
        <Column>
          <TextTitle>{t("__opportunity")}</TextTitle>
          <TextDescription>{`${t("__date_on")} ${DateFormatter.formatDateFull(data.startDate)} - ${DateFormatter.formatDateFull(data.endDate)}`}</TextDescription>
        </Column>
        <Column wrap>
          <SuggestionNumber bgColor={colors.positivePlus} color={colors.positive} number={campaigns.length} />
        </Column>
      </Row>
      <CampaignZone data={campaigns} />
      <Row margin="20px 0 16px 0">
        <ContactSpecialistBtn />
      </Row>
    </Section>
  ) : null;
};

export default Opportunity;
